import {
  Component,
  EventEmitter,
  Input,
  Output,
  OnChanges,
  SimpleChanges,
} from '@angular/core';
import { UploadImageResponse } from '../../lib/services/imageService';
import { JobListingItem } from '../../jobs-module/models/listing.model';
import { FormGroup, FormBuilder } from '@angular/forms';
import { EditorText } from '../../shared-module/components/mj-text-editor/mj-text-editor.component';

@Component({
  selector: 'mj-job-image',
  templateUrl: './job-image.component.html',
  styleUrls: ['./job-image.component.scss'],
})
export class JobImageComponent implements OnChanges {
  @Input() public listingItem: JobListingItem;
  @Output() public onItemScheduledForRemoval = new EventEmitter();
  @Output() public onItemChanged = new EventEmitter<JobListingItem>();

  isImgPickerOn: boolean;
  isColorPickerOn;
  ratio = [16, 9];

  form: FormGroup;

  constructor(private fb: FormBuilder) {
    this.form = this.fb.group({
      title: '',
      title_rich: '',
      image_media_id: '',
      image_url: '',
    });
  }

  ngOnChanges(changes: SimpleChanges) {
    if (
      changes.listingItem &&
      this.listingItem &&
      this.form.value.title !== this.listingItem.title
    ) {
      this.form.patchValue({
        title: this.listingItem.title,
      });
    }
    if (
      changes.listingItem &&
      this.listingItem &&
      this.form.value.title_rich !== this.listingItem.title_rich
    ) {
      this.form.patchValue({
        title_rich: this.listingItem.title_rich,
      });
    }
    if (
      changes.listingItem &&
      this.listingItem &&
      this.form.value.image_media_id !== this.listingItem.image_media_id
    ) {
      this.form.patchValue({
        image_media_id: this.listingItem.image_media_id,
        image_url: this.listingItem.image_url,
      });
    }
  }

  saveTitle($event: EditorText) {
    this.form.patchValue({
      title_rich: $event.rich,
      title: $event.plain,
    });
    this._updateValues();
  }

  saveReceivedImage(event: UploadImageResponse) {
    this.form.patchValue({
      image_media_id: event.id,
      image_url: event.image,
    });
    this._updateValues();
  }

  getImageWithCssFormat(): string {
    if (this.listingItem.image_url) {
      return `url(${this.listingItem.image_url.split('?')[0]})`;
    } else {
      return '';
    }
  }

  _updateValues() {
    this.onItemChanged.emit({ ...this.listingItem, ...this.form.value });
  }
}
